import React, { useState } from "react";
import { validateInput } from "../../utils/Utils";

function InputText({
  name,
  type,
  value,
  className,
  placeholder,
  errorMessage,
  onFocus,
  validationString,
  disabled,
  onValidationChange,
  isInvalid,
  onChange,
  label,
  prefix,
}) {
  const [isValid, setIsValid] = useState(true);

  const handleChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;
    const validationStatus = validateInput(inputValue, validationString);

    onChange(e);
    setIsValid(validationStatus);

    // Notify the parent component about the validation status
    // onValidationChange(inputName, validationStatus);
  };

  return (
    <div>
      {label && <p className="mb-1.5 text-xs text-monochrome-400">{label}</p>}
      <div className="relative w-full">
        <input
          name={name}
          placeholder={placeholder}
          className={`form-input w-full disabled:bg-gray-50 disabled:text-gray-400 ${prefix && "pl-12"} h-12 ${
            (!isValid || isInvalid) && "border-rose-500"
          }`}
          onFocus={onFocus}
          disabled={disabled}
          type={type}
          value={value}
          onChange={handleChange}
        />
        {prefix && (
          <div className="pointer-es-none absolute inset-0 right-auto flex items-center">
            <span className="px-3 text-sm font-medium text-gray-400">
              {prefix}
            </span>
          </div>
        )}
      </div>
      {((!isValid && errorMessage) || isInvalid) && (
        <div className="mt-0.5 text-2xs text-rose-500">
          {isInvalid ? isInvalid : errorMessage}
        </div>
      )}
    </div>
  );
}

export default InputText;
